export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/dashboard',
    /* internal name: '/dashboard' */
    /* no component */
    children: [
      {
        path: '',
        name: '/dashboard/',
        component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/dashboard/index.vue'),
        /* no children */
        meta: {
          "auth": true
        }
      }
    ],
  },
  {
    path: '/login',
    /* internal name: '/login' */
    /* no component */
    children: [
      {
        path: '',
        name: '/login/',
        component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/login/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/lojas',
    /* internal name: '/lojas' */
    /* no component */
    children: [
      {
        path: '',
        name: '/lojas/',
        component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/lojas/index.vue'),
        /* no children */
      },
      {
        path: 'editar',
        /* internal name: '/lojas/editar' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/lojas/editar/[id]',
            component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/lojas/editar/[id].vue'),
            alias: ["/lojas/novo"],
            /* no children */
            meta: {
              "auth": true
            }
          }
        ],
      }
    ],
  },
  {
    path: '/recebimento-mercadorias',
    /* internal name: '/recebimento-mercadorias' */
    /* no component */
    children: [
      {
        path: '',
        name: '/recebimento-mercadorias/',
        component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/recebimento-mercadorias/index.vue'),
        /* no children */
        meta: {
          "auth": true
        }
      },
      {
        path: 'conferencia',
        /* internal name: '/recebimento-mercadorias/conferencia' */
        /* no component */
        children: [
          {
            path: ':loja_id',
            /* internal name: '/recebimento-mercadorias/conferencia/[loja_id]' */
            /* no component */
            children: [
              {
                path: ':pedido_id',
                name: '/recebimento-mercadorias/conferencia/[loja_id]/[pedido_id]',
                component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/recebimento-mercadorias/conferencia/[loja_id]/[pedido_id].vue'),
                children: [
                  {
                    path: '',
                    name: '/recebimento-mercadorias/conferencia/[loja_id]/[pedido_id]/',
                    component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/recebimento-mercadorias/conferencia/[loja_id]/[pedido_id]/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'leitura',
                    name: '/recebimento-mercadorias/conferencia/[loja_id]/[pedido_id]/leitura',
                    component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/recebimento-mercadorias/conferencia/[loja_id]/[pedido_id]/leitura.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'conferir',
        name: '/recebimento-mercadorias/conferir',
        component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/recebimento-mercadorias/conferir.vue'),
        /* no children */
        meta: {
          "auth": true
        }
      },
      {
        path: 'importar',
        name: '/recebimento-mercadorias/importar',
        component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/recebimento-mercadorias/importar.vue'),
        /* no children */
        meta: {
          "auth": true
        }
      }
    ],
  },
  {
    path: '/register',
    /* internal name: '/register' */
    /* no component */
    children: [
      {
        path: '',
        name: '/register/',
        component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/register/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/usuarios',
    /* internal name: '/usuarios' */
    /* no component */
    children: [
      {
        path: '',
        name: '/usuarios/',
        component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/usuarios/index.vue'),
        /* no children */
      },
      {
        path: 'editar',
        /* internal name: '/usuarios/editar' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/usuarios/editar/[id]',
            component: () => import('/home/fabio/Projects/www/belshop/apps/client/src/pages/usuarios/editar/[id].vue'),
            alias: ["/usuarios/novo"],
            /* no children */
            meta: {
              "auth": true
            }
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

